__turbopack_context__.v({
  "block": "_7ZJgq_block",
});
